import HighchartsComponentBase from "./common/HighchartsComponentBase.js";
import * as utils from "./misc/utils.js";
import {
  createRCCAndRegions,
  createSVFAndTreatment,
} from "./common/DropdownHelper.js";

//'#9CA8D2', '#8B98C6', '#7C89BA', '#6D7BAC', '#5F6D9D'
const template = `
<style>
.optionGroup {
  font-weight: bold;
}

.optionChild {
  padding-left: 15px;
}
.skr-select {
    height:35px; 
    border:1px solid #ddd; 
    padding-left: 6px;
    font-weight: 300;
    padding: .375rem .75rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border-radius: .25rem;
    transition: border-color .15s;
    margin-right: 8px;
    margin-top: 8px;
  }
#highchartsContainer .highcharts-color-0 {
  fill: #005092;
  stroke: #005092;
}
#highchartsContainer .highcharts-color-1 {
    fill: #3066ab;
    stroke: #3066ab;
}
#highchartsContainer .highcharts-color-2 {
    fill: #4f7ec5;
    stroke: #4f7ec5;
}
#highchartsContainer .highcharts-color-3 {
    fill: #6a96e0;
    stroke: #6a96e0;
}
#highchartsContainer .highcharts-color-4{
    fill: #85affb;
    stroke: #85affb;
}
#highchartsContainer .highcharts-color-5 {
    fill: #a1c9ff;
    stroke: #a1c9ff;
}
</style>
<div class="instructionsContainer">Välj region, vårdförlopp och behandling</div>
<div id="guiChoices">
<span>
  <span id='regionselector'></span>
  <span id='svfselector'></span>
  <span id='treatmentselector'></span>
</span>
</div>
`;

class SVFYearLeadtimeInterval extends HighchartsComponentBase {
  constructor() {
    super(template);

    this.chartData = {
      chart: {
        type: "column",
      },
      title: {
        text: null,
        align: "left",
      },
      accessibility: {
        description:
          "Diagram som visar spridningen av väntetider och hur utvecklingen har sett ut över tid.",
      },
      subtitle: {
        align: "left",
        useHTML: true,
      },
      loading: {
        hideDuration: 1000,
        showDuration: 1000,
      },
      xAxis: {
        categories: [],

        reversed: false,
        labels: {
          formatter: function () {
            let ret = this.value;
            let idx = ret.indexOf("(");
            let len = ret.length;
            if (idx != -1) {
              ret = ret.slice(0, idx) + "<br/>" + ret.slice(idx, len);
            }
            return ret;
          },
        },
      },
      yAxis: [
        {
          min: 0,
          max: 100,
          title: {
            text: "",
            align: "high",
          },
          labels: {
            overflow: "justify",
          },
        },
        {
          min: 0,
          max: 100,
          title: {
            text: null,
          },
          opposite: true,
        },
      ],
      legend: {
        enabled: true,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        useHTML: true,
        formatter: function () {
          let text =
            "<b>" +
            this.point["year"] +
            ": " +
            this.x +
            "</b> <br> Andel inom intervallet: " +
            this.y +
            "% <br>";
          text += "Antal inom intervallet: " + this.point[this.x] + "<br>";
          text += "Totalt antal: " + this.point["total"] + "<br>";
          return text;
        },
      },
      lang: {
        loading: "Hämtar data...",
        accessibility: {
          chartContainerLabel:
            "Diagrammet visar hur många som startar behandling inom den angivna ledtiden, med fokus på utvecklingen över tid",
          chartTypes: {
            barSingle:
              "Liggande stapeldiagram med {numPoints} {#plural(numPoints, staplar, stapel)}",
          },
          axis: {
            xAxisDescriptionSingular:
              "Diagrammet har 1 X-axel som består av olika regioner",
            yAxisDescriptionSingular:
              "Diagrammet har 1 Y-axel som visar andel personer som utretts per SVF. Intervall: 0 till 100",
          },
          screenReaderSection: {
            beforeRegionLabel: "Början av det interaktiva diagrammet",
            endOfChartMarker: "Slutet av det interaktiva diagrammet",
          },
        },
        contextButtonTitle: "Diagram-meny",
        downloadJPEG: "Ladda ned JPEG-bild",
        downloadPDF: "Ladda ned PDF-dokument",
        downloadPNG: "Ladda ned PNG-bild",
        downloadSVG: "Ladda ned SVG-vektorgrafik",
        downloadCSV: "Ladda ner CSV-fil",
        downloadXLS: "Laddan ner Excel-fil",
        months: [
          "Januari",
          "Februari",
          "Mars",
          "April",
          "Maj",
          "Juni",
          "Juli",
          "Augusti",
          "September",
          "Oktober",
          "November",
          "December",
        ],
        noData: "Ingen data att visa",
        numericSymbols: ["k", "M", "G", "T", "P", "E"],
        printChart: "Skriv ut diagram",
        shortMonths: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "Maj",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Okt",
          "Nov",
          "Dec",
        ],
        thousandsSep: " ",
        weekdays: [
          "Söndag",
          "Måndag",
          "Tisdag",
          "Onsdag",
          "Torsdag",
          "Fredag",
          "Lördag",
        ],
      },
      plotOptions: {
        column: {
          labels: {
            style: {
              width: "100px",
            },
          },
        },
      },
      exporting: {
        enabled: true,
        scale: 1,
        sourceHeight: 600,
        sourceWidth: 800,
        buttons: {
          contextButton: {
            align: "right",
            x: -25,
            y: 0,
            menuItems: [
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              "openInCloud",
            ],
          },
        },
      },
    };
    super.setChartOptions(this.chartData);

    let guiChoices = super.getShadow().querySelector("#guiChoices");
    let regionselector = guiChoices.querySelector("#regionselector");
    let svfselector = guiChoices.querySelector("#svfselector");
    let treatmentselector = guiChoices.querySelector("#treatmentselector");

    createRCCAndRegions(this, regionselector);
    createSVFAndTreatment(this, svfselector, treatmentselector);

    this.loadChartData();
  }

  loadChartData() {
    let colors = [
      "#a1c9ff",
      "#85affb",
      "#6a96e0",
      "#4f7ec5",
      "#3066ab",
      "#005092",
    ];

    let options = "";

    if (this.treatmentcode != null) {
      options += "?codeId=" + this.treatmentcode;
    }

    if (this.service != null) {
      options += (options ? "&" : "?") + "serviceId=" + this.service;
    }

    if (this.region != null && this.region !== "") {
      options += (options ? "&" : "?") + "regionId=" + this.region;
    } else if (this.centre != null) {
      options += (options ? "&" : "?") + "centreId=" + this.centre;
    }

    utils
      .loadJSONP(
        __BACKEND_URL__ +
          "/seam/resource/rest/homeRegion/intervalTrendSVFYearResult" +
          options,
        false
      )
      .then((data) => {
        if (data.ERROR) {
          super.errorNoData("#chartContainer");
          return;
        }

        var years = [];
        let lowResponseWarning = false;
        this.chartData.yAxis[0].title.text = data.titles.yAxis;
        for (var i = 0; i < data.rows.length; i += 1) {
          var point = [];
          for (let j = 0; j < data.xNames[0].length; j++) {
            let infoObj = {};
            this.chartData.xAxis.categories[j] = data.xNames[0][j];
            infoObj.year = data.rows[i][0];
            infoObj.total = data.rows[i][1];
            infoObj[data.xNames[0][j]] = data.rows[i][2 + j];
            infoObj.y = data.rows[i][6 + j];
            years.push(infoObj.year);
            point.push(infoObj);
            if (infoObj.total < 5) {
              lowResponseWarning = true;
            }
          }
          let color = this.year == data.rows[i][0] ? "#005092" : colors[i];
          super.addSeries(data.rows[i][0], point, true, color);
        }
        super.render();
        if (lowResponseWarning) {
          super.setSubtitle(
            "Data dold för vissa år p.g.a. färre än 5 patienter i urvalet"
          );
        }
      })
      .catch((error) => {
        super.errorNoData("#chartContainer");
      });
    super.showLoading(true);
  }

  static get observedAttributes() {
    return ["region", "centre", "service", "treatmentcode"];
  }

  get region() {
    return this.getAttribute("region");
  }

  get centre() {
    return this.getAttribute("centre") || "SWE";
  }

  get service() {
    return this.getAttribute("service");
  }

  set service(value) {
    this.setAttribute("service", value);
  }

  get treatmentcode() {
    return this.getAttribute("treatmentcode");
  }

  set treatmentcode(value) {
    this.setAttribute("treatmentcode", value);
  }

  attributeChangedCallback(name, oldVal, newVal) {
    console.log("name:" + name + ", newVal: " + newVal + ", oldVal: " + oldVal);

    if (name === "region") {
      return;
    }

    this.loadChartData();
  }
}
customElements.define("svf-year-ledtid-intervall", SVFYearLeadtimeInterval);
